import {
  Box,
  Image,
  Text,
  Link,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import { project } from "../utils/data";

const Project = () => {
  const txtColor2 = useColorModeValue("black", "white");
  return (
    <Box p={{ base: "15px", lg: "70px" }}>
      <Text
        fontSize="3xl"
        textAlign={{ base: "center", sm: "center", md: "center" }}
        color="teal.500"
        mt={{ base: "20px", lg: "0px" }}
      >
        Projects
      </Text>

      <Text
        fontSize="sm"
        textAlign={{ base: "center", sm: "center", md: "center" }}
        color={txtColor2}
        mb={15}
      >
        Here are some of my projects
      </Text>

      <Box mt={10}>
        {project.map((item, index) => (
          <Box key={index} borderRadius="20px" w="100%" h="100%">
            <Box
              display="flex"
              mb="10px"
              gap={{ sm: "10", md: "10", lg: "150" }}
              flexDirection={{
                base: "column",
                sm: "column",

                md: index % 2 === 0 ? "row" : "row-reverse",
                lg: index % 2 === 0 ? "row" : "row-reverse",
              }}
              h="100%"
            >
              <Image
                minW={{ base: "100%", sm: "100%", md: "400px", lg: "500px" }}
                h={{ base: "250px", sm: "300px", md: "250px", lg: "250px" }}
                borderRadius={{
                  base: "20px",
                }}
                src={item.img}
              />

              <Box>
                <Text
                  color={txtColor2}
                  fontSize="30px"
                  my={{ base: "10px" }}
                  textDecoration="underline"
                  style={{
                    textDecorationThickness: "2px",
                    textUnderlineOffset: "7px",
                  }}
                >
                  #{index + 1} {item.title}
                </Text>
                <Text color={txtColor2} fontSize="15px" my={{ base: "10px" }}>
                  {item.body}
                </Text>
                <Text fontSize="sm" color={txtColor2}>
                  {item.skill}
                </Text>
                <Box mt="20px">
                  <Link href={item.link} isExternal>
                    <Button
                      color={txtColor2}
                      border="1px"
                      borderColor="white"
                      borderRadius="10px"
                      _hover={{ color: "teal.500" }}
                    >
                      View Project
                    </Button>
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
export default Project;
